import { topTabBarHeight, useIsTabBarPositionedTop } from '@/src/common/components/TopTabBar'
import { View } from 'tamagui'
import { NotificationsButton } from './NotificationsButton'
import { MenuButton } from './MenuButton'
import { MesaLogo } from '@/src/assets/icons/MesaLogo'

export function NavBar() {
  const isTabBarPositionedTop = useIsTabBarPositionedTop()

  if (isTabBarPositionedTop) {
    return <View height={topTabBarHeight} />
  }

  return (
    <View flexDirection="row" items="center" justify="center">
      <View position="absolute" l={0}>
        <MenuButton />
      </View>
      <MesaLogo variant="dualtone-black" height={48} width={100} />
      <View position="absolute" r={0}>
        <NotificationsButton />
      </View>
    </View>
  )
}
